import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';

import * as DbActions from '../actions/db';
import * as LoginActions from '../../../../state-management/actions/login';
import * as AppStateActions from '../../../../state-management/actions/app-state';

import { DbService } from '../../db.service';
import { environment } from '../../../../../../environments/environment';
import { Agency } from '../../../agencies/agencies.model';
import { WebsocketService } from '../../../../services/websocket/websocket.service';
import { isArray, isObject } from 'util';




@Injectable()
export class DbEffects {
	@Effect({dispatch: false}) insert$ = this._actions$
		.ofType<DbActions.Insert>(DbActions.INSERT)
		.map(action => action.payload)
		.switchMap(payload => this._service.put(payload));

	@Effect({dispatch: false}) update$ = this._actions$
		.ofType<DbActions.Update>(DbActions.UPDATE)
		.map(action => action.payload)
		.switchMap(payload => this._service.put(payload));

	@Effect({dispatch: false}) bulkUpdate$ = this._actions$
		.ofType<DbActions.BulkUpdate>(DbActions.BULK_UPDATE)
		.map(action => action.payload)
		.switchMap(payload => this._service.bulkDocs(payload));

	@Effect({dispatch: false}) remove$ = this._actions$
		.ofType<DbActions.Remove>(DbActions.REMOVE)
		.map(action => action.payload)
		.switchMap(payload => this._service.remove(payload));

	@Effect({dispatch: false}) bulkRemove$ = this._actions$
		.ofType<DbActions.BulkRemove>(DbActions.BULK_REMOVE)
		.map(action => action.payload)
		.map(payload => payload.map(item => ({
			_id: item._id,
			_rev: item._rev,
			_deleted: true,
			type: item.type
		})))
		.switchMap(payload => this._service.bulkDocs(payload));

	@Effect({dispatch: false}) onLogin$ = this._actions$
		.ofType<LoginActions.LoginSuccessful>(LoginActions.LOGIN_SUCCESSFUL)
		.map(action => action.payload)
		.do(claims => this._service.initDB(`${environment.couchDB.userDB}/userdb-${claims.sub}`, 'userDB'));

	// TODO: this should trigger a new Effect: .map(agency => new AppStateActions.SelectAgency(agency));
	// TODO: remove websocket from here once the effect can be handled better
	@Effect({dispatch: false}) onAgenciesLoad$ = this._actions$
		.ofType<AppStateActions.SetAgencies>(AppStateActions.SET_AGENCIES)
		.map(action => {
			const defaultAgency: Agency = isArray(action.payload) ? action.payload.find(agency => isObject(agency) && agency.default) : null;

			return isObject(defaultAgency)
				? defaultAgency
				: isArray(action.payload) && action.payload.length && isObject(action.payload[0])
					? action.payload[0]
					: null;
		})
		.do(agency => {
			if (isObject(agency) && agency.agentId) {
				this._service.initDB(`${environment.couchDB.agentDB}/agentdb-${agency.agentId}`, 'agentDB');
				this._websocket.subscribeToChannels([`agent:${agency.agentId}`]);
			}
		});

	@Effect({dispatch: false}) onAgencySelect$ = this._actions$
		.ofType<AppStateActions.SelectAgency>(AppStateActions.SELECT_AGENCY)
		.map(action => action.payload)
		.do(agency => this._service.initDB(`${environment.couchDB.agentDB}/agentdb-${agency.agentId}`, 'agentDB'));

	constructor(private _actions$: Actions, private _service: DbService, private _websocket: WebsocketService) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/db/state-management/effects/db.ts